var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 44.9998,
    r: 45,
    fill: "#209AA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 64.2849C69.9999 64.2638 69.9999 64.2428 69.9999 64.2217V34.8399V34.5346V34.3029C69.9999 34.3224 69.9999 34.3421 69.9999 34.3616V64.2849ZM24.3763 37.8787L22.905 37.0398C21.8359 36.3473 21.1491 35.2102 21.0225 33.9595C21.1296 32.9869 21.6218 32.0905 22.3986 31.4776L43.2238 15.0442C43.8913 14.5176 44.6954 14.2543 45.5006 14.2543C46.3047 14.2543 47.1089 14.5176 47.7764 15.0442L68.6015 31.4776C69.3773 32.0899 69.8702 32.9848 69.9775 33.956C69.8819 34.9109 69.4593 35.7996 68.7908 36.4752V35.3687C68.7908 34.417 68.1438 33.6166 67.2654 33.3836C67.0585 32.4692 66.2417 31.7863 65.2648 31.7863H26.4273C25.2942 31.7863 24.3763 32.7045 24.3763 33.8371V37.8787Z",
    fill: "url(#paint0_linear_579_1014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0889 33.8684C21.1669 32.8505 21.6666 31.906 22.4744 31.2683L43.2708 14.8546C43.9374 14.3286 44.7404 14.0657 45.5445 14.0657C46.3475 14.0657 47.1506 14.3286 47.8172 14.8546L68.6134 31.2683C69.4204 31.9048 69.9194 32.8474 69.9993 33.8632C69.9194 32.8474 69.4204 31.9049 68.6134 31.2684L47.8172 14.8547C47.1506 14.3287 46.3475 14.0658 45.5445 14.0658C44.7404 14.0658 43.9374 14.3287 43.2708 14.8547L22.4744 31.2684C21.6666 31.906 21.1669 32.8505 21.0889 33.8684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0005 34.3616C70.0005 34.3421 70.0005 34.3224 70.0005 34.3029V34.0483C70.0005 34.0681 70.0005 34.0878 70.0005 34.1077V34.3616ZM21.023 33.9595C21.0186 33.9153 21.0148 33.8709 21.0117 33.8264C21.0899 32.8072 21.5902 31.8616 22.3992 31.2232L43.2243 14.7899C43.8919 14.2633 44.696 14 45.5012 14C46.3053 14 47.1095 14.2633 47.777 14.7899L68.602 31.2232C69.4101 31.8605 69.9098 32.8041 69.9898 33.8212C69.9869 33.8662 69.983 33.9113 69.9781 33.956C69.8707 32.9848 69.3779 32.0899 68.602 31.4775L47.777 15.0442C47.1095 14.5176 46.3053 14.2543 45.5012 14.2543C44.696 14.2543 43.8919 14.5176 43.2243 15.0442L22.3992 31.4775C21.6223 32.0905 21.1302 32.9869 21.023 33.9595Z",
    fill: "url(#paint1_linear_579_1014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3144 37.4854V33.8371C67.3144 33.6812 67.2969 33.5294 67.2646 33.3836C68.143 33.6165 68.79 34.417 68.79 35.3687V36.4752C68.5821 36.6855 68.3499 36.8752 68.0961 37.0397L67.3144 37.4854Z",
    fill: "url(#paint2_linear_579_1014)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3247 59.3972H26.481C25.3478 59.3972 24.4297 58.4733 24.4297 57.3336V33.7847C24.4297 32.645 25.3478 31.7211 26.481 31.7211H65.3247C66.4569 31.7211 67.3754 32.645 67.3754 33.7847V57.3336C67.3754 58.4733 66.4569 59.3972 65.3247 59.3972Z",
    fill: "#EDEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8064 36.9702H28.8537C28.5181 36.9702 28.2461 36.7156 28.2461 36.4014V35.1532C28.2461 34.839 28.5181 34.5843 28.8537 34.5843H39.8064C40.1421 34.5843 40.4141 34.839 40.4141 35.1532V36.4014C40.4141 36.7156 40.1421 36.9702 39.8064 36.9702Z",
    fill: "#CDCDCD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2787 41.9805H31.7365L28.2461 39.9427V39.7444C28.2461 39.5299 28.4159 39.356 28.6255 39.356H63.2776C63.3882 39.356 63.4881 39.4046 63.557 39.4822L59.2787 41.9805Z",
    fill: "#CDCDCD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.698 46.9907H46.6043C46.2597 46.8785 45.9014 46.8225 45.5441 46.8225C45.1859 46.8225 44.8276 46.8785 44.483 46.9907H40.3912L35.8818 44.3663H55.2074L50.698 46.9907Z",
    fill: "#CDCDCD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3754 34.3457C67.3754 33.1985 66.4569 32.2685 65.3247 32.2685H26.481C25.3478 32.2685 24.4297 33.1985 24.4297 34.3457V33.7985C24.4297 32.6513 25.3478 31.7212 26.481 31.7212H65.3247C66.4569 31.7212 67.3754 32.6513 67.3754 33.7985V34.3457Z",
    fill: "#F7F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0889 63.9304V33.756C21.0889 33.7133 21.091 33.6726 21.093 33.6298C21.0946 33.6734 21.097 33.7168 21.0999 33.7601C21.0965 33.8055 21.0937 33.851 21.092 33.8968C21.0901 33.9448 21.0892 33.993 21.0892 34.0414V34.4405C21.089 34.4496 21.0889 34.4588 21.0889 34.4682V63.9304ZM69.9993 33.982C69.9983 33.9536 69.9973 33.9251 69.9964 33.8968C69.9944 33.8493 69.9925 33.802 69.9886 33.7549C69.9915 33.7133 69.9934 33.6717 69.9944 33.6298C69.9973 33.6726 69.9993 33.7133 69.9993 33.756V33.982Z",
    fill: "#F4F4F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3759 38.5911L22.9046 37.7521C21.7608 37.0113 21.0548 35.7617 21.0038 34.4084C21.0023 34.4419 21.0006 34.4741 21 34.507V34.1078C21 34.0594 21.001 34.0112 21.0028 33.9632C21.001 34.0112 21 34.0594 21 34.1078V34.3621C21 34.2269 21.0074 34.0925 21.0221 33.9596C21.1487 35.2103 21.8355 36.3473 22.9046 37.0398L24.3759 37.8787V38.5911ZM68.7904 37.1875V36.4753C69.4589 35.7996 69.8815 34.911 69.9771 33.9561C69.9898 34.0707 69.9976 34.1865 69.9996 34.303V34.5347C69.9996 34.4919 69.9976 34.4512 69.9947 34.4084C69.9556 35.4611 69.5194 36.451 68.7904 37.1875Z",
    fill: "url(#paint3_linear_579_1014)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34.3621V34.1077C21 34.0593 21.001 34.0111 21.0028 33.9631C21.0046 33.9173 21.0073 33.8718 21.0107 33.8264C21.0139 33.8709 21.0176 33.9153 21.0221 33.9595C21.0074 34.0924 21 34.2268 21 34.3621ZM69.9996 34.3029C69.9976 34.1864 69.9898 34.0707 69.9771 33.956C69.982 33.9113 69.9859 33.8662 69.9888 33.8212C69.9927 33.8683 69.9947 33.9156 69.9966 33.9631C69.9976 33.9914 69.9986 34.0199 69.9996 34.0483V34.3029Z",
    fill: "url(#paint4_linear_579_1014)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3154 38.1975V37.4853L68.0971 37.0397C68.3509 36.8751 68.5831 36.6854 68.791 36.4751V37.1873C68.5831 37.3976 68.3509 37.5874 68.0971 37.7519L67.3154 38.1975Z",
    fill: "url(#paint5_linear_579_1014)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2469 48.4224L48.6622 48.0461L50.7246 46.8782H51.973L49.2469 48.4224ZM41.8678 48.422L39.1416 46.8782H40.391L42.4524 48.0457L41.8678 48.422ZM56.4952 44.3175H55.2458L59.4097 41.9589H60.6591L56.4952 44.3175ZM35.8698 44.3175H34.6205L30.4565 41.9589H31.7059L35.8698 44.3175ZM28.195 40.6782L24.4297 38.5457V37.838L28.195 39.9707V40.6782ZM63.8137 40.1723V39.7772C63.8137 39.6786 63.7757 39.5887 63.7132 39.5214L67.3754 37.4473V38.1549L63.8137 40.1723Z",
    fill: "#E3E3E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6471 41.9805H59.4001L63.6953 39.5946C63.7576 39.6605 63.7956 39.7485 63.7956 39.845V40.2317L60.6471 41.9805ZM31.7502 41.9805H30.5032L28.2461 40.7269V40.0344L31.7502 41.9805Z",
    fill: "#C4C4C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8625 46.9907H50.6098L55.1466 44.3663H56.4002L51.8625 46.9907ZM40.2406 46.9907H38.9869L34.4502 44.3663H35.7039L40.2406 46.9907Z",
    fill: "#C4C4C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9993 34.4727V64.8125C69.9993 66.038 69.0115 67.0322 67.7948 67.0322H23.2928C22.0762 67.0322 21.0889 66.038 21.0889 64.8125V34.4727C21.0889 34.4297 21.091 34.3888 21.093 34.3458C21.1438 35.7062 21.8486 36.9624 22.9903 37.7072L43.645 49.5689C44.8004 50.3218 46.2898 50.3218 47.4451 49.5689L68.0997 37.7072C69.2395 36.9624 69.9438 35.7062 69.9944 34.3458C69.9973 34.3888 69.9993 34.4297 69.9993 34.4727Z",
    fill: "#F9C82B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4772 48.6609L49.2268 48.4982L68.0997 37.6959C69.2395 36.9536 69.9438 35.7016 69.9944 34.3456C69.9973 34.3886 69.9993 34.4293 69.9993 34.4722V34.778C69.9993 34.7352 69.9973 34.6943 69.9944 34.6516C69.9438 36.0075 69.2395 37.2595 68.0997 38.0017L49.4772 48.6609ZM41.612 48.6605L22.9903 38.0017C21.8486 37.2595 21.1438 36.0075 21.093 34.6516C21.091 34.6943 21.0889 34.7352 21.0889 34.778V34.4722C21.0889 34.4293 21.091 34.3886 21.093 34.3456C21.1438 35.7016 21.8486 36.9536 22.9903 37.6959L41.8624 48.4978L41.612 48.6605Z",
    fill: "#FCDE45"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7911 66.9221H23.2083C21.9887 66.9221 21 65.9335 21 64.7138V64.285C21 62.8703 21.7167 61.5519 22.904 60.7827L41.5604 48.6953L41.8112 48.5329L42.3958 48.1542L43.5962 47.3765C43.8616 47.2045 44.1446 47.072 44.4364 46.9789C44.7819 46.8687 45.141 46.8137 45.5002 46.8137C45.8583 46.8137 46.2175 46.8687 46.5629 46.9789C46.8557 47.072 47.1378 47.2045 47.4032 47.3765L48.6046 48.1546L49.1891 48.5333L49.4399 48.6957L68.0955 60.7827C69.2657 61.5405 69.9781 62.8311 69.9996 64.2218C69.9996 64.2428 69.9996 64.2639 69.9996 64.285C69.9996 62.8703 69.2832 61.5519 68.0955 60.7827L47.4032 47.3765C46.8245 47.0012 46.1618 46.8137 45.5002 46.8137C44.8375 46.8137 44.1749 47.0012 43.5962 47.3765L22.904 60.7827C21.7167 61.5519 21 62.8703 21 64.285V64.6921C21 63.2774 21.7167 61.9589 22.904 61.1897L43.5962 47.7834C44.1749 47.4082 44.8375 47.2206 45.5002 47.2206C46.1618 47.2206 46.8245 47.4082 47.4032 47.7834L68.0955 61.1897C69.2832 61.9589 69.9996 63.2774 69.9996 64.6921V64.7138C69.9996 65.9335 69.011 66.9221 67.7911 66.9221Z",
    fill: "url(#paint6_linear_579_1014)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9996 64.6919C69.9996 63.2772 69.2832 61.9587 68.0955 61.1895L47.4032 47.7833C46.8245 47.408 46.1618 47.2205 45.5002 47.2205C44.8375 47.2205 44.1749 47.408 43.5962 47.7833L22.904 61.1895C21.7167 61.9587 21 63.2772 21 64.6919V64.2848C21 62.8702 21.7167 61.5518 22.904 60.7826L43.5962 47.3763C44.1749 47.0011 44.8375 46.8135 45.5002 46.8135C46.1618 46.8135 46.8245 47.0011 47.4032 47.3763L68.0955 60.7826C69.2832 61.5518 69.9996 62.8702 69.9996 64.2848V64.6919Z",
    fill: "url(#paint7_linear_579_1014)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_579_1014",
    x1: 45.5006,
    y1: 55.2546,
    x2: 45.5006,
    y2: 14.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2AA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#E2AA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545819,
    stopColor: "#E2AA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#FFD231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_579_1014",
    x1: 45.5011,
    y1: 55.2546,
    x2: 45.5011,
    y2: 14.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCC2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#EFCC2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#FFE44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_579_1014",
    x1: 45.4998,
    y1: 55.2545,
    x2: 45.4998,
    y2: 14.8554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#CF9C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#E9C02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_579_1014",
    x1: 45.5002,
    y1: 55.2546,
    x2: 45.5002,
    y2: 14.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#D8A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#F4C92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C92F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_579_1014",
    x1: 45.5002,
    y1: 55.2545,
    x2: 45.5002,
    y2: 14.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#E5C32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#F4DA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_579_1014",
    x1: 45.5008,
    y1: 55.2545,
    x2: 45.5008,
    y2: 14.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6950C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454199,
    stopColor: "#C6950C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884462,
    stopColor: "#DFB82B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFB82B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_579_1014",
    x1: 45.5002,
    y1: 49.6922,
    x2: 45.5002,
    y2: 76.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6BF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444422,
    stopColor: "#F6BF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671683,
    stopColor: "#F6AB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6AB0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_579_1014",
    x1: 45.5002,
    y1: 49.6921,
    x2: 45.5002,
    y2: 76.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444422,
    stopColor: "#FAD83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671683,
    stopColor: "#FACC2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACC2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ba9113b14159c400c08a7b34878cd84a.svg";
export { ForwardRef as ReactComponent };